export default __webpack_public_path__ + "static/media/42-43.731bd9cc.png";